import { AppFormContextProvider } from "@lhd/features/Apps/AppForm";
import { FC } from "react";
import { Outlet, useOutletContext } from "react-router-dom";

const AppFormContextRouteLayout: FC = () => {
  const outletContext = useOutletContext();

  return (
    <AppFormContextProvider>
      <Outlet context={outletContext} />
    </AppFormContextProvider>
  );
};

export default AppFormContextRouteLayout;
